export default function vimeoObjectId(url: string): string {
  const u = new URL(url);
  const path = u.pathname || '';
  // JS Array.slice allows for a negative index to seek from the end -> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice#parameters
  const parts = path
    .split('/')
    .slice(-2)
    // Remove empty string cases
    .filter(s => s);
  if (parts.length != 2) {
    return url;
  }
  return `${parts[0]}/${parts[1]}`;
}
